import { useState } from 'react';

import toast from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import useProject from 'hooks/useProject';
import { CodeFileExtension } from 'types';
import createCodeFileAsBlob from 'api/block/createCodeFileAsBlob';

const useDownload = () => {
  const [selectedFileExtension, setSelectedFileExtension] = useState<CodeFileExtension>('zip');

  const project = useProject();
  const downloadMutation = useMutation({
    mutationFn: createCodeFileAsBlob,
    onSuccess: (blob) => {
      const fileName = `${project.data!.projectName}.${selectedFileExtension}`;
      const a = document.createElement('a');
      a.setAttribute('download', fileName);
      a.href = window.URL.createObjectURL(blob);
      a.click();
    },
    onError: () => {
      toast.error('다운로드에 실패했습니다.');
    },
  });

  const handleDownloadClick = () => {
    downloadMutation.mutate({
      ownerName: project.data!.ownerName,
      projectName: project.data!.projectName,
      fileExtension: selectedFileExtension,
    });
  };

  const handleFileExtensionChange = (newFileExtension: CodeFileExtension) => {
    setSelectedFileExtension(newFileExtension);
  };

  return {
    isPending: downloadMutation.isPending,
    selectedFileExtension,
    onDownloadClick: handleDownloadClick,
    onFileExtensionChage: handleFileExtensionChange,
  };
};

export default useDownload;
